import { connect, useDispatch } from "react-redux";
import { IState } from "../../../../redux/reducers/rootReducers";
import CustomFormLabel from "../../../common/form-label/CustomFormLabel ";
import CustomSelect from "../../../common/customSelect/CustomSelect";
import { useCallback, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import CustomInput from "../../../common/textField/CustomInput";
import { triggerAppAlert } from "../../../../redux/actions/SelfServicePortal/ContactAid/ContactAid";
import CategoryTreeSelection from '../../../../pages/new-ticket/AddCategoryPopup';
import TicketAdditionalField from "../../../TicketManagementSystem/Modules/TicketAdditionalField";
import CloseCategoryOption from "../../../TicketManagementSystem/Modules/CloseCategoryOption";

const TicketTypeDropdown = ({ ticketTypes = [], priorities = [], callback,errors={}, showAdditionalFields=false }: any) => {
    const dispatch = useDispatch();
    const [category, setCategory] = useState<any>(null);
    const [priority, setPriority] = useState<any>(null);
    const [priorityOptions, setPriorityOptions] = useState<any>(null);
    const [selectedTicketType, setSelectedTicketType] = useState<any>(null);
    const [outcomeCategoryId, setOutcomeCategoryId] = useState<any>(null);
    const onCategorySubmit = useCallback((res: any) => {
//         console.log("onCategorySubmit", res, "category");
        setCategory(res)
    }, []);
    const prefillPriorityBasedOnTicketType = (ticketType: any) => {
        setSelectedTicketType(ticketType);
        setCategory(null);
        setPriority(null);
        if (ticketType) {
            let updatedPriority: any = [];
            priorities.filter((item: any) => {
                item?.ticketTypeList.filter((ele: any) => {
                    if (ele?.ticketType?.id == ticketType?.id) {
                        updatedPriority.push(item);
                    }
                });
            });

            setPriorityOptions(updatedPriority);
        } else {
            setPriorityOptions([]);
        }
    };
    useEffect(() => {
        if (callback) {
            callback({
                ticketType: selectedTicketType,
                priority: priority,
                category: category
            });
        }
    }, [selectedTicketType, priority, category]);
    return <>
            <Box className="bulk-update-field col-4">
            <CustomFormLabel
                labelName={"Select Ticket Type"}
                isMandotary={false}
                classNames='sml-txt'
            />
            <CustomSelect
                isOpen={false}
                placeholder="Select Ticket Type"
                width={"100%"}
                name="agentId"
                isColor={false}
                isDisabled={false}
                isError={false}
                helperText={""}
                defaultValue={selectedTicketType}
                options={ticketTypes || []}
                handleChange={prefillPriorityBasedOnTicketType}
                isMulti={false}
                customClassNames="sml-txt-dropdown new-service"
            />
            </Box>
        
        {selectedTicketType && <>
            <Box className="bulk-update-field col-4">
                <CustomFormLabel
                    labelName={"Select Category"}
                    isMandotary={selectedTicketType ? true : false}
                    classNames='sml-txt'
                />
                <CustomInput
                    isDisabled={false}
                    readOnly={true}
                    iconPosition={"start"}
                    icon={false}
                    classNames="bulk-update-field-category"
                    isError={!category && errors?.category ? true : false}
                    label={"Category"}
                    name="category"
                    value={category?.label || ""}
                    onClick={() => {
                        if (selectedTicketType?.id) {
                            dispatch({
                                type: "CATEGORY_POPUP_TICKET_TYPE_ID",
                                payload: selectedTicketType?.id,
                            });
                        } else {
                            dispatch(
                                triggerAppAlert(
                                    "Please choose Ticket type before selecting Category",
                                    "warning"
                                )
                            );
                        }
                    }}
                    onChange={() => { }}
                    helperText={""}
                    placeholder={"Click here to select a Category"}
                />
            </Box>

            <Box className="bulk-update-field col-4">
                <CustomFormLabel
                    labelName={"Select Priority"}
                    isMandotary={selectedTicketType ? true : false}
                    classNames='sml-txt'
                />
                <CustomSelect
                    isOpen={false}
                    placeholder="Select Priority"
                    width={"100%"}
                    name="agentId"
                    isColor={false}
                    isDisabled={false}
                    isError={errors?.priority ? true : false}
                    helperText={""}
                    defaultValue={priority}
                    options={priorityOptions || []}
                    handleChange={(val: any) => {
                        setPriority(val);
                    }}
                    isMulti={false}
                    customClassNames="sml-txt-dropdown new-service"
                />
            </Box>
        
            <Box className="bulk-update-field col-4">
                <CategoryTreeSelection callback={onCategorySubmit} />
            </Box>


            {showAdditionalFields && <>
            <Box className="bulk-update-field col-12">
                    <TicketAdditionalField
                        ticketTypeId={selectedTicketType?.id}
                        wrapperClass="bulk-update-additional-field"
                        showTitle={true}
                        // setAdditionalFields={()=>{}}
                        // additionalFieldserror={{}}
                        // savedsetAdditionalFields={selectedTicketType?.ticketAdditionalField}
                        col={4}
                        idNamespace={`bulk_update`}
                    />
                </Box>

                <Box className="bulk-update-field col-12">
                    <CloseCategoryOption
                        ticketTypeId={selectedTicketType?.id}
                        onSelectOutcome={(outcomeCategoryId) => {
                          setOutcomeCategoryId(outcomeCategoryId); // Save the selected outcome category ID
                        } } 
                        outComeCategoryId={outcomeCategoryId}//{curentTicket?.ticketLogs?.outComeCategoryId}
                    />
                </Box>
            </>}
        </>}
    </>;
};


const mapStateToProps = (state: IState) => {
    return ({
        ticketTypes: state?.TicketsReducer?.allResponses?.TicketTypes,
        priorities: state?.TicketsReducer?.allResponses?.priorities,
    })
};

export default connect(mapStateToProps)(TicketTypeDropdown);
// export default TicketTypeDropdown;